function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { BannerLinks } from '@shared/components/bannerLinks';
import SpzaComponent from '@shared/components/spzaComponent';
import { getWindow } from '@shared/services/window';
import { Constants } from '@shared/utils/constants';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { logger } from '@src/logger';
import { Link, Text } from '@fluentui/react';
import { useHydration } from '@shared/hooks/useHydration';
const bannerLinkClicked = ({ event, linkClickHandle })=>{
    event.stopPropagation();
    linkClickHandle();
};
const BannerContent = ({ data, linkClickHandle })=>{
    const { imgURL, title, description, links } = data;
    return /*#__PURE__*/ _jsx("div", {
        className: 'bannerImgWrapper',
        // eslint-disable-next-line react/forbid-dom-props
        style: {
            backgroundImage: `url(${imgURL})`
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: "bannerText",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "textContinar",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        variant: "xxLarge",
                        as: 'h1',
                        className: "bannerTitle",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        variant: "medium",
                        className: "bannerDescription",
                        children: description
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "bannerLinks",
                        children: /*#__PURE__*/ _jsx(BannerLinks, {
                            links: links,
                            onLinkClick: ({ event })=>bannerLinkClicked({
                                    event,
                                    linkClickHandle
                                })
                        })
                    })
                ]
            })
        })
    });
};
const WrappedBanner = ({ data, bannerClickHandle, children })=>{
    var _links_;
    const { links } = data;
    const url = links === null || links === void 0 ? void 0 : (_links_ = links[links.length - 1]) === null || _links_ === void 0 ? void 0 : _links_.url;
    const isHydrated = useHydration();
    const shouldWrapWithLink = React.useMemo(()=>{
        var _data_links;
        return ((_data_links = data.links) === null || _data_links === void 0 ? void 0 : _data_links.length) > 0;
    }, [
        data.links
    ]);
    return isHydrated && shouldWrapWithLink ? /*#__PURE__*/ _jsx(Link, {
        href: url,
        target: "_blank",
        onClick: bannerClickHandle,
        children: children
    }) : /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
export class Banner extends SpzaComponent {
    renderImpl() {
        return /*#__PURE__*/ _jsx(WrappedBanner, {
            data: this.props.data,
            bannerClickHandle: this.handleBannerClicked,
            children: /*#__PURE__*/ _jsx(BannerContent, {
                data: this.props.data,
                linkClickHandle: this.handleBannerHyperLinkClicked
            })
        });
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "provider", void 0), _define_property(this, "handleBannerHyperLinkClicked", ()=>{
            const payload = {
                page: getWindow().location.href,
                action: Constants.Telemetry.Action.Click,
                actionModifier: Constants.Telemetry.ActionModifier.BannerHyperLink,
                details: this.props.data.title
            };
            this.provider.probe(Constants.Telemetry.ProbeName.LogInfo, payload);
            logger.info(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
        }), _define_property(this, "handleBannerClicked", ()=>{
            const payload = {
                page: getWindow().location.href,
                action: Constants.Telemetry.Action.Click,
                actionModifier: Constants.Telemetry.ActionModifier.BannerClick,
                details: this.props.data.title
            };
            this.provider.probe(Constants.Telemetry.ProbeName.LogInfo, payload);
            logger.info(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
        });
        this.provider = SpzaInstrumentService.getProvider();
    }
}
Banner.contextTypes = {
    loc: PropTypes.func,
    locDateString: PropTypes.func,
    locParams: PropTypes.func
};
